/* eslint-disable no-case-declarations */
import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from 'styled-components'
import DefaultTheme from './themes/default'
import moment from 'moment-timezone'

import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

import { ConnectionProvider } from './contexts/ConnectionProvider'
import { emit } from './utils/EventUtils'

const timeConsole = () => {
  const funcNames = ['debug', 'log', 'info', 'warn', 'error']
  const consoleFuncs = {}
  funcNames.forEach((name) => {
    consoleFuncs[name] = console[name]
  })

  funcNames.forEach((name) => {
    console[name] = (...args) => {
      const time = new Date().getTime()
      consoleFuncs[name].apply(console, [`[${moment(time).format('HH:mm:ss')}]`, ...args])
    }
  })
}
timeConsole()

window.addEventListener('message', (event) => {
  const { type, data } = event.data
  switch (type) {
    case 'session':
      const { sessionToken, deviceId } = data
      emit('session-token', {
        sessionToken,
        deviceId,
      })
      break
    default:
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <ThemeProvider theme={DefaultTheme}>
    <ConnectionProvider>
      <App />
    </ConnectionProvider>
  </ThemeProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
